export const formatDate = (date: string | Date | null | undefined): string => {
  if (!date) {
    return "Data não disponível"; // Mensagem padrão para valores nulos ou indefinidos
  }

  const parsedDate = typeof date === "string" ? new Date(date) : date;

  if (isNaN(parsedDate.getTime())) {
    return "Data inválida"; // Tratamento para datas inválidas
  }

  return `${parsedDate.getDate().toString().padStart(2, "0")}/${(
    parsedDate.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${parsedDate.getFullYear()}`;
};
